<template>
  <div class="client-2">
    <ul id="client-2">
      <!-- <li
        class="my-kefu-qq"
        @mouseenter="handleEnter"
        @mouseleave="handleLeave"
      >
        <div class="my-kefu-main">
          <div class="my-kefu-left">
            <a
              class="online-contact-btn"
              href="http://wpa.qq.com/msgrd?v=3&amp;uin=904618281&amp;site=qq&amp;menu=yes"
              target="_blank"
            >
              <i></i>
              <p class="num">在线咨询</p>
            </a>
          </div>
          <div class="my-kefu-right"></div>
        </div>
      </li>
      <li
        class="my-kefu-tel"
        @mouseenter="handleEnter"
        @mouseleave="handleLeave"
      >
        <div class="my-kefu-tel-main">
          <div class="my-kefu-left">
            <i></i>
            <p>服务热线</p>
          </div>
          <div class="my-kefu-tel-right">400-677-1996</div>
          <div class="my-kefu-tel-right">18337409662</div>
        </div>
      </li> -->
      <!-- <li class="my-kefu-liuyan" @mouseenter="handleEnter" @mouseleave="handleLeave">
        <div class="my-kefu-main">
          <div class="my-kefu-left">
            <a href="/about/zaixianliuyan/" title="在线留言">
              <i></i>
              <p>在线留言</p>
            </a>
          </div>
          <div class="my-kefu-right"></div>
        </div>
      </li> -->
      <!-- <li
        class="my-kefu-weixin"
        @mouseenter="handleEnter"
        @mouseleave="handleLeave"
      >
        <div class="my-kefu-main">
          <div class="my-kefu-left">
            <i></i>
            <p>微信扫一扫</p>
          </div>
          <div class="my-kefu-right"></div>
          <div class="my-kefu-weixin-pic"><img src="@img/ma2.jpg" /></div>
        </div>
      </li> -->
      <li class="my-kefu-ftop" @click="returntop">
        <div class="my-kefu-main">
          <div class="my-kefu-left">
            <a href="javascript:;">
              <i></i>
              <p>返回顶部</p>
            </a>
          </div>
          <div class="my-kefu-right"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      timer: null
    };
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
  },
  methods: {
    returntop() {
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        $("html, body").animate(
          {
            scrollTop: 0
          },
          "slow"
        );
      }
    },
    windowScroll() {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      var ftop = $("#client-2").find(".my-kefu-ftop");
      if (scrollTop > 0) {
        ftop.show();
      } else {
        ftop.hide();
      }
    },
    handleEnter: el => {
      // console.log(el.target.className, el.target.firstChild.scrollWidth);
      var that = el.target,
        W = el.target.firstChild.scrollWidth,
        className = el.target.className;
      this.timer = setTimeout(function() {
        $(that)
          .stop()
          .animate(
            {
              left: 77 - W
            },
            "normal",
            function() {
              if (className == "my-kefu-weixin") {
                $(".my-kefu-weixin-pic").show();
              }
            }
          );
      }, 100);
    },
    handleLeave: (el, done) => {
      var that = el.target,
        W = el.target.firstChild.scrollWidth,
        className = el.target.className,
        _this = this;
      $(".my-kefu-weixin-pic").hide();
      clearTimeout(_this.timer);
      $(that)
        .stop()
        .animate(
          {
            left: 0
          },
          "normal",
          function() {}
        );
    }
  }
};
</script>

<style lang="less">
.client-2 {
  position: fixed;
  // right: -170px;
  // top: 45%;
  right: -20px;
  top: 70%;
  z-index: 900;
  li {
    margin-top: 1px;
    clear: both;
    height: 71px;
    position: relative;
    a {
      text-decoration: none;
    }
    i {
      background: url(~@img/fx.png) no-repeat;
      display: block;
      width: 30px;
      height: 27px;
      margin: 0px auto;
      text-align: center;
    }
    p {
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      overflow: hidden;
      text-align: center;
      color: #fff;
    }
  }

  .my-kefu-qq i {
    background-position: 4px -75px;
  }
  .my-kefu-tel i {
    background-position: 0 -21px;
  }
  .my-kefu-liuyan i {
    background-position: 4px -50px;
  }
  .my-kefu-weixin i {
    background-position: -34px 4px;
  }
  .my-kefu-weibo i {
    background-position: -30px -22px;
  }
  .my-kefu-ftop {
    display: none;
    i {
      width: 33px;
      height: 35px;
      background-position: -27px -51px;
    }
  }
  .my-kefu-left {
    float: left;
    width: 77px;
    height: 47px;
    position: relative;
  }
  .my-kefu-tel-right {
    font-size: 16px;
    color: #fff;
    float: left;
    height: 20px;
    line-height: 20px;
    padding: 0 15px;
    border-left: 1px solid #fff;
    margin-top: 4px;
  }
  .my-kefu-right {
    width: 20px;
  }
  .my-kefu-tel-main {
    background: #13b5b3;
    color: #fff;
    height: 56px;
    width: 247px;
    padding: 9px 0 6px;
    float: left;
  }
  .my-kefu-main {
    background: #13b5b3;
    width: 97px;
    height: 56px;
    position: relative;
    padding: 9px 0 6px;
    float: left;
  }
  .my-kefu-weixin-pic {
    display: none;
    position: absolute;
    left: -130px;
    top: -24px;
    z-index: 333;
    img {
      width: 115px;
      height: 115px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/side.vue